import { useState } from "react";
import { usePopularCityQuery } from "../api/queries/cityQueries";

export const usePopularCities = () => {
  const [hoveredTab, setHoveredTab] = useState<number | null>(null);
  const [selectArea, setSelectArea] = useState<number | null>(null);
  const [selectCountry, setSelectCountry] = useState<number | null>(null);
  const { data: poplularCitiesRes } = usePopularCityQuery();

  const handleMouseEnter = (menuName: number | null) => {
    if (menuName !== hoveredTab) {
      setSelectArea(0);
      setHoveredTab(menuName);
      setSelectCountry(0);
    }
  };

  const handleMouseLeave = () => {
    setSelectArea(0);
    setHoveredTab(null);
    setSelectCountry(0);
  };
  return {
    hoveredTab,
    selectArea,
    selectCountry,
    poplularCitiesRes,
    handleMouseEnter,
    handleMouseLeave,
    setHoveredTab,
    setSelectArea,
    setSelectCountry,
  };
};

export type TUsePopularCitiesRes = ReturnType<typeof usePopularCities>;
